<template>
  <div>
    <el-dialog
      ref="addEditViewDialog"
      v-dialogDrag
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      class="h660_dialog abow_dialog"
      width="1200px"
      :before-close="modalClose"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      append-to-body
    >
      <el-form
        ref="dialogAddEditViewForm"
        :model="dialogAddEditViewForm"
        :rules="eventType==='view' ? null : dialogAddEditViewFormRules"
        class="add-edit-view-form"
        @submit.native.prevent
      >
        <div class="modal-box">
          <h3 class="modal-title">
            基础信息
          </h3>
          <div class="modal-row-box">
            <el-row :gutter="10">
              <el-col :span="6">
                <el-form-item label="省区">
                  <el-input
                    v-model="dialogAddEditViewForm.provinceName"
                    disabled
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="城市">
                  <el-input
                    v-model="dialogAddEditViewForm.cityName"
                    disabled
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="方案名称">
                  <el-input
                    v-model="dialogAddEditViewForm.schemeName"
                    disabled
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="方案编号">
                  <el-input
                    v-model="dialogAddEditViewForm.schemeNo"
                    disabled
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="活动名称">
                  <el-input
                    v-model="dialogAddEditViewForm.activityName"
                    disabled
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="活动日期">
                  <el-input
                    v-model="dialogAddEditViewForm.activityDate"
                    disabled
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="活动场所">
                  <el-input
                    v-model="dialogAddEditViewForm.storeNames"
                    disabled
                  />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="10">
              <el-col :span="6">
                <el-form-item label="人员名称">
                  <el-input
                    v-model="dialogAddEditViewForm.userName"
                    disabled
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="问题生成时间">
                  <el-input
                    v-model="dialogAddEditViewForm.warningTime"
                    disabled
                  />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="问题内容">
                  <el-input
                    v-model="dialogAddEditViewForm.warningInfo"
                    disabled
                  />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row
              v-if="dialogAddEditViewForm.isAuditInfo === 1"
              :gutter="10"
            >
              <el-col :span="6">
                <el-form-item label="是否审核生成">
                  <el-input
                    v-model="dialogAddEditViewForm.isAuditInfoValue"
                    disabled
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="审核人">
                  <el-input
                    v-model="dialogAddEditViewForm.auditorName"
                    disabled
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="审核结果">
                  <el-input
                    v-model="dialogAddEditViewForm.auditResultValue"
                    disabled
                  />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="10">
              <el-col :span="6">
                <el-form-item label="处理状态">
                  <el-input
                    v-model="dialogAddEditViewForm.processStatusValue"
                    disabled
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="处理人">
                  <el-input
                    v-model="dialogAddEditViewForm.processUserName"
                    disabled
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="处理时间">
                  <el-input
                    v-model="dialogAddEditViewForm.processTime"
                    disabled
                  />
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="处理说明">
                  <el-input
                    v-model="dialogAddEditViewForm.processInfo"
                    type="textarea"
                    disabled
                  />
                </el-form-item>
              </el-col>
            </el-row>
          </div>
        </div>
        <div class="modal-box">
          <h3 class="modal-title">
            备注信息
          </h3>
          <div class="modal-row-box">
            <el-row :gutter="10">
              <el-col :span="24">
                <el-form-item prop="remark">
                  <el-input
                    v-model="dialogAddEditViewForm.remark"
                    type="textarea"
                    maxlength="512"
                    placeholder="备注"
                    disabled
                  />
                </el-form-item>
              </el-col>
            </el-row>
          </div>
        </div>
      </el-form>

      <div
        slot="footer"
        class="dialog-footer"
      >
        <el-button @click="modalClose">
          关闭
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
// dialog 拖拽
import dialogDragMixin from '@/mixin/dialogDragMixin'
// 终端恢复申请API
import { viewActivityWarningInfoListApi } from '@/api/v2/activityWarningInfoList';

export default {
  components: { },
  mixins: [dialogDragMixin],
  props: {
    dialogTitle: {
      type: String,
      default: ''
    },
    eventType: {
      type: String,
      default: ''
    },
    dialogVisible: {
      type: Boolean,
      default: false
    },
    dataId: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      expandMoreData: false,
      dialogAddEditViewForm: {},
      dialogAddEditViewFormRules: {}
    }
  },
  watch: {
    dialogVisible (val) {
      if (val) {
        let _this = this;

        _this.dialogAddEditViewForm = {}
        if (_this.eventType !== 'add') {
          _this.loadActivityWarningInfoListData();
        }

        _this.$nextTick(() => {
          _this.$refs.dialogAddEditViewForm.clearValidate()
        })
      }
    },
  },
  methods: {
    // 加载数据
    loadActivityWarningInfoListData () {
      let _this = this;
      viewActivityWarningInfoListApi({ id: _this.dataId }).then((response) => {
        const { data } = response;
        _this.dialogAddEditViewForm = data
      })
    },
    modalClose () {
      let _this = this;
      _this.$emit('update:dialogVisible', false);
      _this.imageFileList = [];
      _this.$refs.dialogAddEditViewForm.clearValidate();
    }
  }
}
</script>
<style lang="scss" scoped>
</style>
